import axios, { AxiosInstance } from 'axios'
import Cookies from 'universal-cookie/es6'

import { STORAGEKEYS } from '../../common/keys'
import { affiliatePartnersNames } from '../../pages/AffiliatePage/affiliatePartnersData'
import { SessionStorage } from '../../common/cookie-storage'
import { Environment } from '../../environment/app-settings'

// ========================== TYPES & INTERFACES ==========================
type TYouMoneyCallbackStatus = 'lead' | 'sale'
// ========================================================================

//#region YouMoneyService Instance
let youMoneyinstance: YouMoneyService
//#endregion

class YouMoneyService {
   private readonly _youMoneyCallbackBaseApiUrl = 'https://callback.youmoney.pl';
   private readonly _youMoneyAffiliateUrlPath = "/opena-aff";
   public readonly youMoneyCallbackStatuses = {
      lead: 'lead',
      sale: 'sale'
   };

   constructor() {
    if (youMoneyinstance) { //SINGLETON DESIGN PATTERN
       throw new Error("New instance cannot be created!!");
    }
 
    youMoneyinstance = this;
   }

   /**
    * Metoda pomocnicza zwracająca gotowy link do postbacka, wraz z odpowiednimi parametrami zapytania (query params)
    * 
    * @param status 'lead' | 'sale'
    * @returns 
    */
   private _preparePostbackLink (status: TYouMoneyCallbackStatus): string | undefined  {
      const cookie = new Cookies();
      const currentAffiliateCookie = cookie.get(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE)
      const sessionStorage = new SessionStorage()

      if(Boolean(currentAffiliateCookie)){
         if(currentAffiliateCookie.partnerId === affiliatePartnersNames.YouMoney){   
            const requestedAmountFromLoanCalculator = JSON.parse(sessionStorage.get(STORAGEKEYS.LOAN_CALCULATOR_STATE)).requestedAmount
            const alphaId = sessionStorage.get(STORAGEKEYS.SET_ALPHA_ID) //!! IMPORTANT - METODA TA MUSI ZOSTAĆ WYWOŁANA NA ETAPIE GDZIE NUMER WNIOSKU JEST ZNANY
      
            const youMoneyCallbackQueryParams = new URLSearchParams({
               status,
               click_id: currentAffiliateCookie.urlParams.click_id,
               order_id: alphaId,
               amount: requestedAmountFromLoanCalculator
            })
      
            return `${this._youMoneyCallbackBaseApiUrl + this._youMoneyAffiliateUrlPath}?${youMoneyCallbackQueryParams.toString()}`
         }
      }
   }

   /**
    * Funkcja tworząca wrapper dla metody Fetch. Przyjmuje status (sale / lead) i na tej podstawie próbuje stworzyć link do Postbacka.
    * Jeśli uda jej się stworzyć odpowiedni link, wykonuje metodę fetch z odpowiednią konfiguracją.
    * 
    * @param statusType "lead" | "sale"
    * @returns 
    */
   private async _sendPostbackRequestHelper(statusType: TYouMoneyCallbackStatus) {
      const currentAppUrl = window.location.origin
      const youMoneyCallbackUrl = this._preparePostbackLink(statusType)

      if(currentAppUrl.includes(Environment.OPENA_FORM_PRD_URL) && youMoneyCallbackUrl !== undefined){ // POSTBACK wykonujemy TYLKO NA PRODUKCJI
         await fetch(youMoneyCallbackUrl, { mode: 'no-cors', method: "GET" }).catch(e => console.error("Nie udało się wykonać zapytania Postback dla partnera YouMoney."))   
      }
   }
 
   /**
    * Funkcja obsługująca mechanizm POSTBACK partnera YouMoney dla LEAD'A
   */
   public async sendLeadPostback(): Promise<void> {
      await this._sendPostbackRequestHelper(this.youMoneyCallbackStatuses.lead as TYouMoneyCallbackStatus) //LEAD
   }

   /**
    * Funkcja obsługująca mechanizm POSTBACK partnera YouMoney dla SPRZEDAŻY (SALE)
   */
   public async sendSalePostback(): Promise<void> {
      await this._sendPostbackRequestHelper(this.youMoneyCallbackStatuses.sale as TYouMoneyCallbackStatus) //SALE
   }   
}
 
 let youMoneyService = Object.freeze(new YouMoneyService())//SINGLETON DESIGN PATTERN
 export default youMoneyService;